<button mat-button class="btn_secondary_outline"
  [ngClass]="{'btn_secondary_outline_icon-right': !iconPosition, 'btn_secondary_outline_icon-left': iconPosition}"
  [style.width]="resolvedWidth"
  [style.maxWidth]="resolvedWidth"
  [disabled]="disabled" (click)="onClick()">
  <mat-icon [class]="iconClass" *ngIf="icon && typeIcon">{{ icon }}
  </mat-icon>
  {{ label }}
</button>